import ReactDOMClient from "react-dom/client";
import { WorldGlobe } from "./components/WorldGlobe";
import { WorldFlatMap } from "./components/WorldFlatMap";
import { QueryClient, QueryClientProvider } from "react-query";
import "./styles/app.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 1000,
    },
  },
});
const root = ReactDOMClient.createRoot(document.getElementById("root")!);

// ?flat=true renders the flat equirectangular map; otherwise the 3D globe.
const isFlat = new URLSearchParams(window.location.search).get("flat") === "true";

root.render(
  <QueryClientProvider client={queryClient}>
    {isFlat ? <WorldFlatMap /> : <WorldGlobe />}
  </QueryClientProvider>
);
